import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export type SurveyEvent = {
  type: SurveyTriggerType;
  timestamp: number;
  open?: boolean;
};
declare global {
  interface Window {
    abortSurvey: SurveyEvent[];
    playgroundSurvey: SurveyEvent[];
    aiTravelPlannerSurvey: SurveyEvent[];
  }
}
export const dispatchSurveyEvent = (event: SurveyEventDetail) => {
  const eventObj = new CustomEvent<SurveyEventDetail>(`${event.event}`, {
    detail: event
  });
  window.dispatchEvent(eventObj);
};
interface SurveyEventDetail {
  event: SurveyTriggerType;
  [key: string]: any;
}
type SurveyTriggerType = 'generalSurvey';
export function useSurveyTrigger(triggerType) {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [events, setEvents] = useState(t0);
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  let t2;
  if ($[1] !== triggerType) {
    t1 = () => {
      if (typeof window === "undefined" || !triggerType) {
        return;
      }
      const handleBeforeUnload = _event => {
        const surveyData = {
          type: triggerType,
          timestamp: Date.now()
        };
        window[triggerType] = [...(window[triggerType] || []), surveyData];
        setEvents(window[triggerType]);
        setIsOpen(false);
      };
      const handleSurveyTrigger = () => {
        const surveyData_0 = {
          type: triggerType,
          timestamp: Date.now()
        };
        window[triggerType] = [...(window[triggerType] || []), surveyData_0];
        setEvents(window[triggerType]);
        setIsOpen(true);
      };
      window.addEventListener("beforeunload", handleBeforeUnload);
      window.addEventListener(triggerType, handleSurveyTrigger);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        window.removeEventListener(triggerType, handleSurveyTrigger);
      };
    };
    t2 = [triggerType];
    $[1] = triggerType;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== events || $[5] !== isOpen) {
    t3 = {
      surveyEvents: events,
      isOpen,
      setIsOpen
    };
    $[4] = events;
    $[5] = isOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}